import {useContext} from 'react';

import {FormikValues} from 'formik';
import {useTranslation} from 'react-i18next';

import {Box} from '@mui/material';

import {AdminsMultiSelect} from './AdminsMultiSelect';
import {EmpionButton} from '../../../../../../../../../components/EmpionButton/EmpionButton';
import EmpionDialog from '../../../../../../../../../components/EmpionDialog/EmpionDialog';
import {LoadingOverlay} from '../../../../../../../../../components/Loading/LoadingOverlay';
import {LoadingContext} from '../../../../../../../../../contexts/LoadingContext/LoadingContext';
import {useQueryParameterState} from '../../../../../../../../../hooks/useQueryParameterState';
import {greenColors, orangeColors} from '../../../../../../../../../layouts/theme/designSystem';
import {AssignAdminsProps} from '../../../../ListView/ButtonActions/MenuButtonActions';

interface Props {
  open: boolean;
  onClose: () => void;
  formik: FormikValues;
}

export const AssignJobPostingAdminsModal = ({open, onClose, formik}: Props) => {
  const {setLoadingContext} = useContext(LoadingContext);

  const {t: td} = useTranslation('translation', {keyPrefix: 'companyJobPostings.assignAdminsModal'});
  const {t: ts} = useTranslation('translation', {keyPrefix: 'shared.formButtons'});

  const {params} = useQueryParameterState<AssignAdminsProps>();

  const onCloseButton = () => {
    formik.setFieldValue('companyAdminIds', formik.initialValues.companyAdminIds);
    onClose();
  };

  return (
    <EmpionDialog
      open={open}
      onClose={() => {
        onCloseButton();
      }}
      title={td('title')}
      subTitle={td('description')}
      backgroundColor={orangeColors[4]}
      sxTitle={{
        fontSize: '28px',
        fontWeight: 700,
        lineHeight: '42px',
      }}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '736px',
            padding: '32px',
            borderRadius: '16px',
          },
        },
      }}
    >
      <AdminsMultiSelect formik={formik} />
      <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'} gap={2} marginTop={6}>
        <EmpionButton
          onClick={() => {
            onCloseButton();
          }}
          sx={{
            backgroundColor: greenColors[600],
            '&:hover': {
              backgroundColor: greenColors[700],
            },
          }}
        >
          {ts('cancel')}
        </EmpionButton>
        <EmpionButton
          onClick={() => {
            if (params.assignAdmins === 'true') {
              setLoadingContext(true);
              formik.submitForm();
            }
            onClose();
          }}
        >
          {ts('save')}
        </EmpionButton>
      </Box>
      <LoadingOverlay />
    </EmpionDialog>
  );
};
